import HorizontalBarChart from "./HorizontalBarChart"
import { ProjectDashboardViewModel } from "../../api/project-dashboard"
import { Typography } from "@material-ui/core"
import { OVERDUE_START_COLOR, STATUS_COLORS } from "../../../constants"
import { useTranslations } from "./useTranslations"

const useOtherTasksBarChart = ({ projectDashboard }: OtherTasksBarChartProps) => {
  const translations = useTranslations()
  const {
    numberOfNotCompletedTasks,
    numberOfNotCompletedOnTimeTasks,
    numberOfNotCompletedLateTasks,
    numberOfNotCompletedPastStartTasks,
    numberOfNotCompletedOtherTasks,
    notCompletedOnTimeTasks,
    notCompletedLateTasks,
    notCompletedPastStartTasks,
    notCompletedOtherTasks,
  } = projectDashboard
  const notCompletedOnTimeTasksPercentage = (
    (numberOfNotCompletedOnTimeTasks / numberOfNotCompletedTasks) *
    100
  ).toFixed(1)
  const notCompletedLateTasksPercentage = ((numberOfNotCompletedLateTasks / numberOfNotCompletedTasks) * 100).toFixed(1)
  const notCompletedPastStartTasksPercentage = (
    (numberOfNotCompletedPastStartTasks / numberOfNotCompletedTasks) *
    100
  ).toFixed(1)
  const notCompletedOtherTasksPercentage = ((numberOfNotCompletedOtherTasks / numberOfNotCompletedTasks) * 100).toFixed(
    1
  )
  const displayBarChart = numberOfNotCompletedTasks > 0

  const onTimeColor = STATUS_COLORS.COMPLETED["1"]
  const lateColor = STATUS_COLORS.REJECTED["2"]
  const otherColor = STATUS_COLORS.NOT_STARTED["1"]
  const pastStartColor = OVERDUE_START_COLOR

  const labels = [
    {
      label: translations.onTimeLabel,
      boxColor: onTimeColor,
    },
    {
      label: translations.lateLabel,
      boxColor: lateColor,
    },
    {
      label: translations.pastStartLabel,
      boxColor: pastStartColor,
    },
    {
      label: translations.noScheduleLabel,
      boxColor: otherColor,
    },
  ]

  const data = [
    {
      value: numberOfNotCompletedOnTimeTasks,
      percentage: notCompletedOnTimeTasksPercentage,
      tooltipContent: notCompletedOnTimeTasks,
      backgroundColor: onTimeColor,
    },
    {
      value: numberOfNotCompletedLateTasks,
      percentage: notCompletedLateTasksPercentage,
      tooltipContent: notCompletedLateTasks,
      backgroundColor: lateColor,
    },
    {
      value: numberOfNotCompletedPastStartTasks,
      percentage: notCompletedPastStartTasksPercentage,
      tooltipContent: notCompletedPastStartTasks,
      backgroundColor: pastStartColor,
    },
    {
      value: numberOfNotCompletedOtherTasks,
      percentage: notCompletedOtherTasksPercentage,
      tooltipContent: notCompletedOtherTasks,
      backgroundColor: otherColor,
    },
  ]
  return {
    displayBarChart,
    labels,
    data,
    translations,
  }
}

const OtherTasksBarChart = ({ projectDashboard }: OtherTasksBarChartProps) => {
  const { labels, data, displayBarChart, translations } = useOtherTasksBarChart({ projectDashboard })

  if (!displayBarChart) {
    return (
      <Typography variant="body2" color="textSecondary">
        {translations.noData}
      </Typography>
    )
  }
  return <HorizontalBarChart labels={labels} data={data} />
}

export default OtherTasksBarChart
type OtherTasksBarChartProps = {
  projectDashboard: ProjectDashboardViewModel
}
